<template>
  <div v-loading="infoLoading">
    <ContentHeader path-set-type="replace" />

    <div class="content-container">
      <OrderBaseInfo
        :tradeApplyOrderVO="orderInfo"
        :tradeApplyInfoVO="tradeApplyInfoVO"
        :tradeApplyBaseVO="tradeApplyBaseVO"
        :perfectInfo="perfectInfo"
        @handleSuccess="init"
      >
        <!-- 订单状态进度 -->
        <OrderStepInfo ref="OrderStepInfo" :tradeApplyOrderVO="orderInfo" isPerfect />
      </OrderBaseInfo>

      <!-- 完美门店参与资格 -->
      <div class="trade-order-block" style="display: flex; align-items: center" v-if="canModifyStatus">
        <div class="block-title">门店{{ applyTypeName }}参与资格</div>
        <div style="margin-left: 50px">
          <el-switch
            disabled
            :active-value="1"
            :inactive-value="0"
            v-model="tradeApplyBaseVO.isStack"
            active-color="#409EFF"
            inactive-color="#C0CCDA"
            @click.native="clickSwitch"
          />
        </div>
      </div>

      <div class="extend-box trade-order-block" v-if="orderInfo && (orderInfo.originPerfectApplyOrderInfo || orderInfo.extendPerfectApplyOrderInfo)">
        <!-- 续签前订单 -->
        <PerfectExtendItem
          v-if="orderInfo.originPerfectApplyOrderInfo"
          title="续签前订单"
          :info="orderInfo.originPerfectApplyOrderInfo"
          :perfectInfo="perfectInfo"
        />
        <!-- 续签后订单 -->
        <PerfectExtendItem
          v-if="orderInfo.extendPerfectApplyOrderInfo"
          title="续签后订单"
          :info="orderInfo.extendPerfectApplyOrderInfo"
          :perfectInfo="perfectInfo"
        />
      </div>

      <!-- 订单明细 -->
      <InfoCollapse infoTitle="订单明细">
        <StoreBaseInfo
          v-if="perfectInfo && basePocInfo.abiOneId"
          ref="StoreBaseInfo"
          :tradeApplyOrderVO="orderInfo"
          :tradeApplyInfoVO="tradeApplyInfoVO"
          :tradeApplyBaseVO="tradeApplyBaseVO"
          :basePocInfo="basePocInfo"
          :tradeApplyExecVO="tradeApplyExecVO"
        />
        <PocBaseInfo
          ref="pocBaseInfo"
          :applyTypeName="applyTypeName"
          :tradeApplyOrderVO="orderInfo"
          :tradeApplyInfoVO="tradeApplyInfoVO"
          :tradeApplyBaseVO="tradeApplyBaseVO"
          :basePocInfo="basePocInfo"
          :tradeApplyExecVO="tradeApplyExecVO"
          v-else
        />
      </InfoCollapse>

      <!-- 活动配置信息 -->
      <InfoCollapse infoTitle="活动配置信息" v-if="perfectInfo">
        <div class="trade-order-block">
          <div class="block-content">
            <el-row class="content-row" style="margin-top: 0; color: #c8102d">
              <el-col :span="3">预计总投入</el-col>
              <el-col :span="20">
                <div v-for="(item, index) in activityTotal" :key="index">{{ item }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="trade-order-block">
          <div class="block-title">{{ perfectInfo.privateThemeName }}</div>
          <div class="block-content" v-if="perfectInfo">
            <el-row class="content-row">
              <el-col :span="3">主题名称</el-col>
              <el-col :span="9">{{ perfectInfo.perfectThemeName }}</el-col>
              <el-col :span="3">活动时间</el-col>
              <el-col :span="9">{{ perfectInfo.startDate | parseTime('{y}-{m}-{d}') }} 至 {{ perfectInfo.endDate | parseTime('{y}-{m}-{d}') }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">计划开始时间</el-col>
              <el-col :span="9">{{ perfectInfo.realStartTime }}</el-col>
              <el-col :span="3">计划结束时间</el-col>
              <el-col :span="9">{{ perfectInfo.realEndTime }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">打卡频次（天/次）</el-col>
              <el-col :span="9">{{ perfectInfo.execDaysCycle }}</el-col>
              <el-col :span="3">预计打卡次数</el-col>
              <el-col :span="9">{{ perfectInfo.clockNumberDays }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">陈列追踪方式</el-col>
              <el-col :span="9">{{ perfectInfo.trackTypeName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">费用返还方式</el-col>
              <el-col :span="9">
                <div>{{ perfectInfo.bonusTypeName }}</div>
                <div
                  v-if="perfectInfo.bonusType === '01' || perfectInfo.bonusType === '02' || perfectInfo.bonusType === '05'"
                  style="font-size: 12px; color: #ccc"
                >
                  陈列费/次 {{ perfectInfo.bonusTotal | numberToCurrency(true) }}元
                </div>
                <div v-if="perfectInfo.bonusType === '03'" style="font-size: 12px; color: #ccc">
                  <div>{{ perfectInfo.bonusBeerSkuName }}</div>
                  <div>每次赠酒数 {{ perfectInfo.bonusTotal | numberToCurrency(true) }}箱</div>
                </div>
              </el-col>
              <el-col :span="3" v-if="perfectInfo.bonusType === '04'">赠酒券有效时间</el-col>
              <el-col :span="9" v-if="perfectInfo.bonusType === '04'">{{
                beesCouponAssignRule.type === '01' ? `发券后${beesCouponAssignRule.validDays}天内` : '永久有效'
              }}</el-col>
            </el-row>
            <div class="bees-bonus-beer" v-if="perfectInfo.bonusType === '04'">
              <div class="th-col">
                <div class="th">年月</div>
                <div class="td">赠酒品类</div>
                <div class="td">赠酒数</div>
              </div>
              <div v-for="(monthInfo, key, index) in beesBonusBeerList" :key="index" class="sku-info">
                <div class="th">{{ key }}</div>
                <div style="display: flex">
                  <div v-for="(sku, index) in monthInfo" :key="index" style="flex: 1">
                    <div class="td" style="padding: 0 10px">{{ sku.skuName }}</div>
                    <div class="td">{{ sku.value | numberToCurrency(true) }}箱/次</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 任务列表 -->
            <InfoCollapse titleType="task" infoTitle="STR任务" v-if="isDealStr">
              <el-row class="content-row">
                <el-col :span="3">首月销量计算初始日</el-col>
                <el-col :span="9">{{ perfectInfo.salesCalcDate | parseTime('{y}-{m}-{d}') }}</el-col>
              </el-row>
              <InfoCollapse titleType="str" :isInfoShow="getStatusText(key) === '进行中' ? true : false" v-for="(item, key) in strList" :key="key">
                <span slot="strName" style="margin-right: 10px">
                  <span class="str-title">{{ `${key.split('-')[0]}年${key.split('-')[1]}月考核任务` }}</span>
                </span>
                <span slot="strStatus" :style="{ color: getStatusColor(key) }" v-if="tradeApplyInfoVO.applyStatus === '300'" style="margin-left: 10px"
                  >({{ getStatusText(key) }})</span
                >
                <el-table
                  v-if="item"
                  :data="item"
                  border
                  max-height="550"
                  style="width: 100%"
                  :header-cell-style="{
                    background: '#ebf4ff',
                    color: '#1b1c1d',
                    textAlign: 'center',
                    fontSize: '14px'
                  }"
                >
                  <el-table-column label="考核目标" align="center" width="250" fixed="left">
                    <template slot-scope="scope">
                      <div class="sonItemStyle">
                        <div v-for="(item, index) in scope.row.items" :key="index">
                          <div v-if="item.name">
                            <div v-for="(i, idx) in item.name.split(',')" :key="idx" class="item-list">{{ i }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="目标销量" align="center">
                    <template slot-scope="scope">
                      <div>{{ scope.row.qty }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="当前销量" align="center">
                    <template slot-scope="scope">
                      <div
                        class="td"
                        v-if="getCurrentDate(scope.row.month)"
                        :class="{
                          'str-red': currentSalesInfo[scope.row.month] && currentSalesInfo[scope.row.month].complete === 3,
                          'str-green': !(currentSalesInfo[scope.row.month] && currentSalesInfo[scope.row.month].complete === 3)
                        }"
                      >
                        {{ String(getCurrentNum(scope.row.month, scope.row.scopeDefineId)) | thousandSymbol }}箱
                      </div>
                      <div class="td" v-else>/</div>
                    </template>
                  </el-table-column>
                </el-table>
              </InfoCollapse>
            </InfoCollapse>
            <div v-for="(item, index) in perfectInfo.tradeApplyExecPerfectList" :key="index">
              <InfoCollapse titleType="task" :infoTitle="item.perfectTaskName" v-if="item.perfectTaskType !== '05'">
                <PerfectTaskInfo ref="perfectTaskInfo" :info="item" :trackType="perfectInfo.trackType" />
              </InfoCollapse>
            </div>
          </div>
        </div>
        <div class="trade-order-block">
          <div class="block-content">
            <el-row class="content-row" style="margin-top: 0">
              <el-col :span="3">其它照片</el-col>
              <el-col v-if="perfectInfo.execImageList" :span="21" v-viewer="{ movable: true }" class="info-img">
                <div class="img-wrapper" v-for="img in perfectInfo.execImageList" :key="img.pocImageId">
                  <img :src="getImg(img.imageUri)" />
                </div>
              </el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">提报说明</el-col>
              <el-col :span="21">{{ perfectInfo.execDesc }}</el-col>
            </el-row>
          </div>
        </div>
      </InfoCollapse>

      <!-- 能量包执行信息 -->
      <InfoCollapse infoTitle="门店执行信息" v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '107'">
        <div class="trade-order-block">
          <div class="block-title">能量包</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">能量包类型</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.energyPacketWay === '01' ? '总部礼包' : '事业部礼包' }}</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetCode" :span="3">礼包编码</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetCode" :span="9">{{ tradeEnergyPacketInfo.packetCode }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetChannel" :span="3">礼包渠道</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetChannel" :span="9">{{ tradeEnergyPacketInfo.packetChannel }}</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetDesc" :span="3">礼包组成明细</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetDesc" :span="9">{{ tradeEnergyPacketInfo.packetDesc }}</el-col>
            </el-row>
            <el-row class="content-row" v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.includeItemFlag">
              <el-col :span="3">是否包含消费者物料</el-col>
              <el-col :span="9">是</el-col>
            </el-row>
          </div>
        </div>
      </InfoCollapse>

      <!-- 夏季能量包执行信息   -->
      <InfoCollapse infoTitle="门店执行信息" v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '108'">
        <div class="trade-order-block">
          <div class="block-title">夏季能量包</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">执行人姓名</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPerson }}</el-col>
              <el-col :span="3">执行人电话</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">礼包活动</el-col>
              <el-col :span="9">{{ packetType }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetCode" :span="3">礼包编码</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetCode" :span="9">{{ tradeEnergyPacketInfo.packetCode }}</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetChannel" :span="3">礼包渠道</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetChannel" :span="9">{{ tradeEnergyPacketInfo.packetChannel }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetDesc" :span="3">礼包组成明细</el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetDesc" :span="9">
                <!-- {{ tradeEnergyPacketInfo.packetDesc }}{{packetDescList}} -->
                <div v-for="(item, index) in packetDescList" :key="index">{{ index + 1 + '.' + item }}</div>
              </el-col>
              <el-col v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.packetDesc" :span="3">礼包图片</el-col>
              <el-col :span="9" v-viewer="{ movable: true }" class="info-img">
                <img :src="packUrl" />
              </el-col>
            </el-row>
            <el-row class="content-row" v-if="tradeEnergyPacketInfo && tradeEnergyPacketInfo.includeItemFlag">
              <el-col :span="3">是否包含消费者物料</el-col>
              <el-col :span="9">是</el-col>
            </el-row>
          </div>
        </div>
      </InfoCollapse>

      <!-- 青柠礼包执行信息 -->
      <InfoCollapse infoTitle="门店执行信息" v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '109'">
        <div class="trade-order-block">
          <div class="block-title">青柠大行动</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">执行人姓名</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPerson }}</el-col>
              <el-col :span="3">执行人电话</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">执行类型</el-col>
              <el-col :span="9">{{ lemonTypeName }}</el-col>
              <el-col :span="3" v-if="tradeApplyExecLemonInfo.lemonCode">礼包编码</el-col>
              <el-col :span="9" v-if="tradeApplyExecLemonInfo.lemonCode">{{ tradeApplyExecLemonInfo.lemonCode }}</el-col>
            </el-row>
            <el-row class="content-row" v-if="packetImgList.length">
              <el-col :span="3">礼包照片</el-col>
              <el-col :span="21" v-viewer="{ movable: true }" class="info-img">
                <div class="img-wrapper" v-for="img in packetImgList" :key="img.title">
                  <img :src="getImg(img.imageUri)" />
                  <div class="img-wrapper-title">{{ img.title }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </InfoCollapse>

      <!-- 操作记录 -->
      <InfoCollapse infoTitle="操作记录">
        <OrderProcessInfo ref="OrderProcessInfo" :processRecordList="processRecordList" />
      </InfoCollapse>

      <!-- 操作按钮 -->
      <div class="order-info info-btn" v-show="isMineApproval">
        <div :class="{ fixed: isFixed }">
          <el-button class="btn-red-plain" size="small" @click="handleReject">驳回</el-button>
          <el-button class="btn-red" size="small" @click="handlePass">通过</el-button>
        </div>
      </div>

      <!-- 弹窗提示 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span v-if="handleText">{{ handleText }}</span>
        <el-input v-else placeholder="请填写理由" v-model="approvalFormData.processRemark"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button class="btn-red" size="small" @click="e => handleConfirm(false)" :loading="btnLoading">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 成功弹窗 -->
      <el-dialog title="提示" :visible.sync="succVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <span>{{ successText }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="returnList">返回</el-button>
          <el-button class="btn-red" size="small" @click="showInfo">查看详情</el-button>
        </span>
      </el-dialog>

      <!-- 禁用/启用弹窗 -->
      <ModifyStatusDialog
        ref="modifyStatusDialog"
        :forbiddenForm="forbiddenForm"
        :disableReason="disableReason"
        :btnLoading="btnLoading"
        :enableForm="enableForm"
        :rules="rules"
        :orderInfo="orderInfo"
        @forbiddenConfirm="forbiddenConfirm"
        @enableConfirm="enableConfirm"
      />
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import { mapState, mapGetters } from 'vuex'
import { commonUtils } from '@/utils/common'
import { parseTime, numberToCurrency } from '@/filters'
import ContentHeader from '@/components/content-header'
import OrderBaseInfo from './components/order-base-info'
import OrderStepInfo from './components/order-step-info'
import InfoCollapse from './components/info-collapse'
import PerfectTaskInfo from './components/perfect-task-info'
import OrderProcessInfo from './components/order-process-info'
import ModifyStatusDialog from './components/modify-status-dialog'
import PerfectExtendItem from './components/perfect-extend-item'
import PocBaseInfo from './components/poc-base-info'
import StoreBaseInfo from './components/store-base-info'

export default {
  name: 'perfect-order-info',
  components: {
    ContentHeader,
    OrderBaseInfo,
    OrderStepInfo,
    InfoCollapse,
    PerfectTaskInfo,
    OrderProcessInfo,
    ModifyStatusDialog,
    PerfectExtendItem,
    PocBaseInfo,
    StoreBaseInfo
  },
  data () {
    return {
      forbiddenForm: {
        reason: '',
        remark: '',
        disableExtendFlag: null
      },
      rules: {
        reason: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        remark: [
          { required: false, message: '请填写活动形式', trigger: 'blur' }
        ]
      },
      enableForm: {
        remark: ''
      },
      infoLoading: false,
      btnLoading: false,
      forbiddendialog: false,
      enabledialog: false,
      orderInfo: null,
      tradeApplyInfoVO: {},
      tradeApplyBaseVO: null,
      tradeApplyExecPerfectVOList: [],
      tradeApplyExecVO: null,
      basePocInfo: {},
      tradeEnergyPacketInfo: null,
      processRecordList: [],
      employeeLevel: null,

      isMineApproval: false,
      isMineApply: false,
      perfectInfo: null,

      approvalFormData: {
        applyId: '',
        approvalResult: '', // 01提交，02审批通过，03审批退回
        processRemark: '', // 如驳回，驳回理由
        approvalType: '01' // 01需求审批 02费用审批 03验收审批
      },

      isFixed: true,
      dialogVisible: false,
      succVisible: false,
      handleText: '',
      successText: '',
      tradeApplyExecLemonInfo: {},
      activityTotal: [],
      currentSalesInfo: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      disableReason: state => state.base.tradeApplyProcessPerfectReasonMap,
      //夏季礼包 第几期活动
      packetType () {
        const arr = {
          A: '夏季能量包-1期',
          B: '夏季能量包-2期'
        }
        return arr[this.tradeEnergyPacketInfo.packetType]
      },
      // 礼包图片
      packUrl () {
        if (this.tradeEnergyPacketInfo && this.tradeEnergyPacketInfo.packetType === 'A') {
          return ' https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/abipocm/CNY/2022kbd-pachet-desc.png'
        } else {
          return 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/abipocm/CNY/2022kbd-pachet-desc-2.png'
        }
      }
    }),

    // 是否可以修改完美门店参与资格
    canModifyStatus () {
      if (!this.orderInfo) return
      return this.tradeApplyInfoVO.applyStatus === '300' &&
        this.perfectInfo?.orderStartTime < +new Date()
    },

    applyTypeName () {
      if (this.perfectInfo) {
        const typeMap = {
          '105': '完美门店',
          '106': 'PBO'
        }
        return typeMap[this.perfectInfo.execTypeSub]
      }
      if (this.tradeApplyExecVO?.execTypeSub === '107') {
        return '能量包'
      }
      if (this.tradeApplyExecVO?.execTypeSub === '109') {
        return '青柠大行动'
      }
      return ''
    },
    packetDescList () {
      return this.tradeEnergyPacketInfo.packetDesc.split(',')
    },

    lemonTypeName () {
      if (this.tradeApplyExecLemonInfo?.lemonType === '012' &&
        this.tradeApplyExecLemonInfo.upgradeStatus === 10) {
        return '有青柠礼包'
      } else {
        return this.tradeApplyExecLemonInfo?.lemonTypeName
      }
    },
    // 礼包图片
    packetImgList () {
      if (this.tradeApplyExecLemonInfo) {
        let imgTypeList = []
        if (this.tradeApplyExecLemonInfo.lemonType === '021') {
          imgTypeList = [
            { title: '冰柜陈列+瓶颈套', imgKey: 'cardPhoto' },
            { title: '冰柜贴执行', imgKey: 'coolerPhoto' },
            { title: '礼包到店照片', imgKey: 'packetPhoto' }
          ]
        } else {
          imgTypeList = [
            { title: '青柠台卡', imgKey: 'cardPhoto' },
            { title: '青柠冰柜贴', imgKey: 'coolerPhoto' },
            { title: '青柠礼包', imgKey: 'packetPhoto' }
          ]
        }
        let imgList = []
        imgTypeList.forEach((item) => {
          if (this.tradeApplyExecLemonInfo[item.imgKey]) {
            imgList.push({
              title: item.title,
              imageId: this.tradeApplyExecLemonInfo[item.imgKey],
              imageUri: this.tradeApplyExecLemonInfo[`${item.imgKey}Uri`]
            })
          }
        })
        return imgList
      }
      return []
    },
    // 交易门店且有str任务
    isDealStr () {
      if (this.basePocInfo.beesPocFlag && this.perfectInfo && this.perfectInfo.tradeApplyExecPerfectList.length) {
        if (String(this.basePocInfo.beesPocFlag) === '1' && this.perfectInfo.tradeApplyExecPerfectList.filter(
          item => item.perfectTaskType === '05'
        ).length) {
          return true
        }
      }
      return false
    },
    beesCouponAssignRule () {
      let beesCouponAssignRule = ''
      if (this.perfectInfo.beesCouponAssignRule) {
        beesCouponAssignRule = JSON.parse(this.perfectInfo.beesCouponAssignRule)
      }
      return beesCouponAssignRule
    },
    beesBonusBeerList () {
      let bonusInfo = this.perfectInfo.tradePerfectBonusGroupDTO
      const { bonusGroupDetailList = [] } = bonusInfo
      if (!this.perfectInfo || !bonusGroupDetailList.length) return []
      let arr = []
      bonusGroupDetailList.forEach(item => {
        if (item.values && item.values.length) {
          item.values.forEach(val => {
            const obj = {
              skuCode: item.skuCode,
              skuName: item.skuName,
              month: val.month,
              value: val.value
            }
            item = obj
            arr.push(item)
          })
        }
      })
      const group = arr.reduce((pre, item) => {
        pre[item.month] = [...(pre[item.month] || []), item]
        return pre
      }, {})
      return group
    },
    strList () {
      // let { saleScopeList = [], realStartTime, realEndTime } = this.perfectInfo.tradeApplyExecPerfectList.find(item => item.perfectTaskType === '05')
      let { saleScopeList = [] } = this.perfectInfo.tradeApplyExecPerfectList.find(item => item.perfectTaskType === '05')
      if (!saleScopeList.length) return []
      let strInfo = {}
      saleScopeList.forEach(item => {
        let info = item.salesRuleInfoVO
        if (info.targets && info.targets.length) {
          info.targets.forEach(str => {
            if (!strInfo[str.month]) {
              strInfo[str.month] = [str]
            } else {
              strInfo[str.month] = [...strInfo[str.month], str]
            }
          })
        }
      })
      return strInfo
    },
    // 是否是完美门店2.0
    isPerfectSecond () {
      if (this.perfectInfo && this.perfectInfo.tradeApplyExecPerfectList?.length) {
        const stackVersion = this.perfectInfo.tradeApplyExecPerfectList[0]?.stackVersion
        return parseInt(stackVersion) > 6
      }
      return false
    }
  },
  watch: {
    $route () {
      this.infoLoading = true
      this.init()
    }
  },
  mounted () {
    this.init()
    const _self = this
    window.onscroll = function () {
      _self.isFixed = true
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        _self.isFixed = false
      }
    }
  },
  methods: {
    init () {
      this.$store.dispatch(
        'getDictByName',
        'tradeApplyProcessPerfectReasonMap'
      )
      this.getOrderInfo()
    },

    // 获取订单详情
    getOrderInfo () {
      this.$store
        .dispatch('getOrderInfo', this.$route.query.applyId)
        .then(res => {
          this.infoLoading = false
          if (res.data.resultCode === '0') {
            this.orderInfo = res.data.resultData.tradeApplyOrderVO
            this.setOrderInfo()
          }
        })
    },
    // 设置订单信息
    async setOrderInfo () {
      this.employeeLevel = this.userInfo.employeeLevel
      this.tradeApplyInfoVO = this.orderInfo.tradeApplyInfoVO
      this.tradeApplyBaseVO = this.orderInfo.tradeApplyBaseVO
      this.basePocInfo = this.orderInfo.basePocInfo
      this.tradeApplyExecPerfectVOList =
        this.orderInfo.tradeApplyExecPerfectVOList || []
      this.tradeApplyExecVO = this.orderInfo.tradeApplyExecVO
      this.tradeEnergyPacketInfo = this.orderInfo.tradeApplyExecVO?.tradeEnergyPacketInfo

      this.processRecordList = this.orderInfo.processRecordList || []
      this.tradeApplyExecLemonInfo = this.orderInfo.tradeApplyExecLemonInfo
      if (this.orderInfo.tradeApplyExecPerfectVOList) {
        this.perfectInfo = this.orderInfo.tradeApplyExecPerfectVOList[0]
        this.perfectInfo.realStartTime = parseTime(
          this.perfectInfo.realStartTime,
          '{y}-{m}-{d}'
        )
        this.perfectInfo.realEndTime = parseTime(
          this.perfectInfo.realEndTime,
          '{y}-{m}-{d}'
        )
        this.perfectInfo.clockNumberDays =
          this.getClockTotal(this.perfectInfo)

        this.getPerfectTotal(this.perfectInfo)
        // 交易门店且有str任务
        if (this.isPerfectSecond) {
          await this.getPerfectTaskExecDetail()
          if (this.isDealStr) {
            this.perfectInfo.tradeApplyExecPerfectList = this.setPerfectStrList(this.perfectInfo)
          }
        }
      }

      // 设置堆箱设计图
      if (this.perfectInfo) {
        if (this.perfectInfo.tradeApplyExecPerfectList) {
          this.perfectInfo.tradeApplyExecPerfectList.forEach((item, index) => {
            let colorList = []
            if (item.perfectTaskType === '01' || item.scopeDefineType === '04') {
              if (item.stackDesignColorList) {
                colorList = item.stackDesignColorList
              } else {
                if (item.stackBrandColor) {
                  colorList = [
                    {
                      brandName: item.subBrandDesc
                        ? item.subBrandDesc
                        : item.brandDesc,
                      color: item.stackBrandColor
                    }
                  ]
                }
                if (item.mixinPackOrderList.length) {
                  item.mixinPackOrderList.forEach(temp => {
                    if (temp) {
                      colorList.push({
                        brandName: temp.abiBrandDesc,
                        color: temp.tradeStackColor
                      })
                    }
                  })
                }
              }
              this.$set(item, 'stackDesignColorList', colorList)
              this.$nextTick(() => {
                this.$refs.perfectTaskInfo[index].setDesignInfo()
              })
            }
          })
        }
      }

      // 审批人是否是本人
      if (
        this.userInfo.clientId === this.tradeApplyInfoVO.approvalClientId ||
        (this.userInfo.regionTMClientId ===
          this.tradeApplyInfoVO.approvalClientId &&
          this.userInfo.employeeLevel === 45)
      ) {
        this.isMineApproval = true
      } else {
        this.isMineApproval = false
      }

      // this.tradeApplyBaseVO.isStack = Boolean(this.tradeApplyBaseVO.isStack)

      // 是否是本人提报
      this.isMineApply =
        this.userInfo.clientId === this.tradeApplyInfoVO.applyClientId

      this.$nextTick(() => {
        if (this.$refs.OrderStepInfo) {
          this.$refs.OrderStepInfo.setOrderStatusList(this.orderInfo)
        }
        if (this.perfectInfo && this.basePocInfo.abiOneId) {
          this.$refs.StoreBaseInfo.initMap(this.basePocInfo)
        } else {
          this.$refs.pocBaseInfo.initMap(this.basePocInfo)
        }
      })
    },
    getPerfectTaskExecDetail () {
      return new Promise((resolve, reject) => {
        tradeApi.getPerfectTaskExecDetail({ applyNumber: this.tradeApplyInfoVO.applyNumber }).then(res => {
          if (res.data.resultCode === '0') {
            resolve()
            if (this.isPerfectSecond) {
              const trackRecordList = res.data.resultData.applyPerfectExeDetailVO?.trackRecordList || []
              const list = trackRecordList.filter(item => {
                if (this.tradeApplyBaseVO.disableTime) {
                  return item.trackStartDate <= this.tradeApplyBaseVO.disableTime
                }
                return true
              })
              this.$set(this.orderInfo.tradeApplyExecPerfectVOList[0], 'tradePerfectTrackRecordList', list)
            }
            if (!this.isDealStr) return
            this.currentSalesInfo = res.data.resultData.applyPerfectExeDetailVO?.salesMap || {}
            const date = new Date()
            let month = Number(date.getMonth() + 1)
            let year = Number(date.getFullYear())
            // 2未达标 1已达标 3进行中 4未开始
            Object.keys(this.currentSalesInfo).forEach(key => {
              const keyMonth = Number(key.split('-')[1])
              const keyYear = Number(key.split('-')[0])
              let flag = 1
              if (year === keyYear) {
                if (month < keyMonth) {
                  flag = 4
                } else if (month === keyMonth) {
                  flag = 3
                }
              } else if (year < keyYear) {
                flag = 4
              }
              const obj = {
                ...{
                  complete: flag
                },
                ...this.currentSalesInfo[key].salesDetailMap
              }
              this.currentSalesInfo[key] = obj
            })
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 禁用资格
    forbiddenConfirm (ref, isRequired) {
      if (this.btnLoading) return
      ref.validate(valid => {
        if (valid) {
          if (isRequired && this.forbiddenForm.disableExtendFlag === null) {
            this.$message.error('请选择是否同时禁用续签订单')
            return
          }
          const params = Object.assign({},
            {
              applyNumber: this.tradeApplyInfoVO.applyNumber,
              reason: this.forbiddenForm.selectreason
            },
            this.forbiddenForm
          )

          this.btnLoading = true
          this.$store.dispatch('disabledPerfect', params).then(res => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.$refs.modifyStatusDialog.forbiddenDialogClose()
              this.init()
            }
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    // 启用资格
    enableConfirm () {
      if (this.employeeLevel !== 50) {
        return
      }
      if (this.btnLoading) return
      const params = {
        applyNumber: this.tradeApplyInfoVO.applyNumber,
        remark: this.enableForm.remark
      }
      this.btnLoading = true
      this.$store.dispatch('enablePerfect', params).then(res => {
        this.btnLoading = false
        if (res.data.resultCode === '0') {
          this.$refs.modifyStatusDialog.enabledialogClose()
          this.init()
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
    // 活动参与资格
    clickSwitch () {
      if (!this.checkPoc()) return
      if (this.isDealStr && this.tradeApplyBaseVO.isStack === 1) {
        this.$confirm('此操作可能会导致售点本月无法获得任务奖励, 是否继续?', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.tradeApplyBaseVO.isStack) {
            this.forbiddenForm.selectreason = ''
            this.forbiddenForm.remark = ''
            this.forbiddenForm.disableExtendFlag = null
            this.$refs.modifyStatusDialog.forbiddenDialogShow()
          } else {
            if (this.employeeLevel !== 50) {
              return
            }
            if (!this.checkPoc()) return
            this.enableForm.remark = ''
            this.$refs.modifyStatusDialog.enabledialogShow()
          }
        }).catch(() => {
        })
        return
      }
      if (this.tradeApplyBaseVO.isStack) {
        this.forbiddenForm.selectreason = ''
        this.forbiddenForm.remark = ''
        this.forbiddenForm.disableExtendFlag = null
        this.$refs.modifyStatusDialog.forbiddenDialogShow()
      } else {
        if (this.employeeLevel !== 50) {
          return
        }
        if (!this.checkPoc()) return
        this.enableForm.remark = ''
        this.$refs.modifyStatusDialog.enabledialogShow()
      }
    },
    // 驳回
    handleReject () {
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'reject'
    },

    // 通过
    handlePass () {
      if (!this.checkPoc()) return
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'pass'
    },

    handleConfirm (notCheckRemark) {
      if (this.btnLoading) {
        return
      }
      this.approvalFormData.applyId = this.orderInfo.applyId

      // 审批驳回
      if (this.handleType === 'reject') {
        this.successText = '订单驳回成功'
        if (!this.approvalFormData.processRemark && !notCheckRemark) {
          this.$message.error('请填写驳回理由')
          return
        }
        this.approvalFormData.approvalResult = '03'
      }

      // 审批通过
      if (this.handleType === 'pass') {
        this.successText = '订单审批成功'
        this.approvalFormData.approvalResult = '02'
        this.approvalFormData.type = '02'
      }

      // 百威
      this.btnLoading = true
      this.$store
        .dispatch('handleApprove', this.approvalFormData)
        .then(res => {
          this.btnLoading = false
          if (res.data.resultCode === '0') {
            this.dialogVisible = false
            this.succVisible = true
          }
        })
        .catch(() => {
          this.btnLoading = false
        })
    },

    returnList () {
      this.$router.go(-1)
    },
    showInfo () {
      this.succVisible = false
      this.init()
    },
    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },

    checkPoc () {
      this.getOrderInfo()
      // 完美门店订单， 中台售点， 临时关店、永久关店， 不能通过订单，自动关闭
      if (this.perfectInfo && this.basePocInfo.abiPocId && (this.basePocInfo.abiPocStatus === 2 || this.basePocInfo.abiPocStatus === 3)) {
        this.$confirm('该门店已临时关店/永久关店，无法参与活动。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'reject'
              this.handleConfirm(true)
            }
          }
        })
        return false
      }
      if (this.perfectInfo && this.basePocInfo.abiPocId && this.basePocInfo.channelCode !== this.tradeApplyInfoVO.channelCode) {
        this.$alert('该门店已变更主渠道，无法参与活动。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '好的',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            // if (action === 'confirm') {
            //   this.handleType = 'reject'
            //   this.handleConfirm(true)
            // }
          }
        })
        return false
      }
      return true
    },
    // perfect 2.0

    // 获取时间段总打卡频次
    getClockTotal ({ realStartTime, realEndTime, execDaysCycle }) {
      let clockNumberDays = 0
      if (realStartTime && realEndTime && execDaysCycle) {
        const startDate = new Date(realStartTime).getTime() - 24 * 60 * 60 * 1000
        const endDate = new Date(realEndTime).getTime()
        const num = (endDate - startDate) / (24 * 60 * 60 * 1000)
        clockNumberDays = Math.ceil(num / execDaysCycle)
      }
      return clockNumberDays
    },
    // 获取每月打卡频次
    getClockFrequency ({ realStartTime, realEndTime, execDaysCycle }) {
      const end = new Date(realEndTime)
      let curr = new Date(realStartTime)
      let arr = []
      let num = 1
      while (curr <= end) {
        let currDay = curr.getDate()
        const copy = new Date()
        let currLasDate = new Date(copy.setTime(curr.getTime()))
        currLasDate.setDate(1)
        currLasDate.setMonth(currLasDate.getMonth() + 1)
        const currLastDay = new Date(
          currLasDate.getTime() - 1000 * 60 * 60 * 24
        )
        let lastDay = currLastDay > end ? end : currLastDay
        lastDay = new Date(lastDay).getDate()
        currDay = Number(currDay) + Number(execDaysCycle)
        if (currDay > lastDay) {
          arr.push(num)
          num = 0
        }
        num++
        curr = new Date(curr.getTime() + 1000 * 60 * 60 * 24 * execDaysCycle)
      }
      return arr
    },
    // 每个活动预计总投入
    getActivityTotal ({ perfectInfo, clockFrequency }) {
      const { tradePerfectBonusBeerGroupList = [], tradePerfectBonusGroupDTO } =
        perfectInfo || {}
      let beerInfo = null
      if (!tradePerfectBonusBeerGroupList.length) {
        beerInfo = tradePerfectBonusGroupDTO || {}
      } else {
        beerInfo = tradePerfectBonusBeerGroupList.find(
          val => val.groupId === perfectInfo.bonusGroupId
        )
      }
      let activityTotal = []
      beerInfo.bonusGroupDetailList.forEach(sku => {
        let total = 0
        sku.values.forEach((val, index) => {
          if (clockFrequency[index]) {
            total += Number(val.value) * Number(clockFrequency[index])
          }
        })
        const skuInfo = `${sku.skuName} （${numberToCurrency(total, true)}箱）`
        activityTotal.push(skuInfo)
      })
      return activityTotal
    },
    // 完美门店免费酒预计总投入
    getPerfectTotal (item) {
      if (item.bonusType === '04') {
        const clockFrequency = this.getClockFrequency(item)
        this.activityTotal = this.getActivityTotal({
          perfectInfo: item,
          clockFrequency
        })
      } else if (item.bonusType === '03') {
        this.activityTotal = [`${item.bonusBeerSkuName} （${numberToCurrency(item.bonusTotal * item.clockNumberDays, true)}箱）`]
      } else {
        this.activityTotal = [`${item.bonusType === '05' ? '折扣金' : '陈列费'}（${numberToCurrency(item.bonusTotal * item.clockNumberDays, true)}元）`]
      }
    },
    // 获取详情合并str任务
    setPerfectStrList (perfectVOInfo) {
      const noStrList = perfectVOInfo.tradeApplyExecPerfectList.filter(
        item => item.perfectTaskType !== '05'
      )
      const strRuleList = perfectVOInfo.tradeApplyExecPerfectList.filter(
        item => item.perfectTaskType === '05'
      )
      const info = {
        perfectThemeCode: perfectVOInfo.perfectThemeCode,
        perfectTaskName: strRuleList[0].perfectTaskTypeName,
        perfectTaskType: '05',
        realStartTime: perfectVOInfo.realStartTime,
        realEndTime: perfectVOInfo.realEndTime,
        salesCalcDate: parseTime(perfectVOInfo.salesCalcDate, '{y}-{m}-{d}'),
        saleScopeList: strRuleList,
        checkResult: 1
      }
      const strRuleInfo = { ...strRuleList[0], ...info }
      return [...noStrList, strRuleInfo]
    },
    // 有没有当前销量
    getCurrentDate (key) {
      let keyDate = new Date(key).getTime()
      if (keyDate > new Date().getTime()) {
        return false
      } else {
        return true
      }
      // return Object.keys(this.currentSalesInfo).some(month => {
      //   return month === key
      // })
    },
    // 当月销量
    getCurrentNum (monthKey, taskId) {
      const info = this.currentSalesInfo[monthKey] || {}
      return info[taskId] || 0
    },
    getStatusText (key) {
      const obj = {
        2: '未达标',
        1: '已达标',
        3: '进行中',
        4: '未开始'
      }
      return obj[this.currentSalesInfo[key]?.complete] || ''
    },
    getStatusColor (key) {
      const obj = {
        2: '#cd1231',
        1: '#44c200',
        3: '#298df8',
        4: '#298df8'
      }
      return obj[this.currentSalesInfo[key]?.complete] || '#44c200'
    },
    getBeerName (name) {
      if (!name) return
      return name.split(',')
    }
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  padding-bottom: 20px;
}

::v-deep .el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer !important;
}

::v-deep .el-switch.is-disabled {
  opacity: 1;
}

::v-deep .el-textarea,
::v-deep .el-select {
  width: calc(100% - 30px);
}

::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin: 0px -67px 0px 0px;
}
::v-deep .el-form-item__label {
  margin-right: 10px;
}
.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  line-height: 100px;
  background: #f3f5f9;
  z-index: 10;
}
.info-btn {
  text-align: center;
  height: 42px;
  .el-button {
    padding-left: 40px;
    padding-right: 40px;
    margin: 10px 25px 0 25px;
  }
}
.info-img {
  img {
    width: 110px;
    height: 110px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}
.img-wrapper {
  display: inline-block;
  padding-right: 10px;
}
.extend-box {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}
.bees-bonus-beer {
  display: flex;
  text-align: center;
  margin-top: 20px;
  overflow-y: hidden;
  overflow-x: scroll;
  flex-wrap: nowrap;
  & > div {
    flex: 1;
    .th {
      height: 40px;
      // font-size: 16px;
      font-weight: 700;
      line-height: 40px;
      background-color: #ebf4ff;
      border-right: 1px solid #e5e5e5;
    }
    .td {
      height: 40px;
      line-height: 40px;
      border-right: 1px solid #e5e5e5;
      border-top: 1px solid #e5e5e5;
      white-space: nowrap;
    }
  }
  .th-col {
    min-width: 120px;
    max-width: 120px;
  }
  .sku-info {
    .td {
      min-width: 100px;
    }
  }
}
.str-red {
  color: $base-red;
}
.str-green {
  color: #44c200;
}
</style>
<style lang="scss">
.el-message-box .el-message-box__btns {
  margin-top: 20px;
  text-align: center;
  .el-button--primary {
    background-color: #c8102d;
    border-color: #c8102d;
  }
}
.el-message-box__wrapper {
  bottom: 350px;
}
</style>
